// extracted by mini-css-extract-plugin
module.exports = {"drop-zone":"DropZone_drop-zone__Yi51n","overlay":"DropZone_overlay__75f40"};